var map = {
	"./battery_0blue.png": "ecb7",
	"./battery_0classic.png": "2ceb",
	"./battery_0disable.png": "f3ed",
	"./battery_0green.png": "a14d",
	"./battery_0orange.png": "5e2e",
	"./battery_0purple.png": "24cb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ee0d";